<template>
    <div>
        <div v-if="!isHeader">
            <p aosType v-if="readMoreActivated" v-html="longDesc"></p>
            <a
                v-if="readMoreActivated"
                @click="activateReadMore"
                href="javascript:void(0)"
            >
                {{ $t('general.Read more') }}...
            </a>
            <p v-if="!readMoreActivated" v-html="longDesc"></p>
        </div>
        <div v-if="isHeader">
            <h1 v-if="readMoreActivated" v-html="longDesc"></h1>
            <a
                v-if="readMoreActivated"
                @click="activateReadMore"
                href="javascript:void(0)"
            >
                {{ $t('general.Read more') }}...
            </a>
            <h1 v-if="!readMoreActivated" v-html="longDesc"></h1>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Readmore',
    props: {
        longText: String,
        isHeader: {
            type: Boolean,
            default: false,
        },
        hasAOS: {
            type: Boolean,
            default: false,
        },
        aosType: String,
    },
    data() {
        return {
            readMoreActivated: false,
        }
    },
    watch: {
        longText: {
            immediate: true,
            handler: function () {
                this.readMoreActivated = this.longText.length > 200
            },
        },
    },
    computed: {
        longDesc() {
            let tempText, resultText
            tempText = this.longText.replace(/<[^>]*>?/gm, '')
            if (this.readMoreActivated) {
                resultText = tempText.slice(0, 200)
            } else {
                resultText = tempText
            }
            return resultText
        },
    },
    methods: {
        activateReadMore() {
            this.readMoreActivated = false
        },
    },
}
</script>
